import useSound from '@/composables/useSound'
import {useStreamStore} from '@/stores/streamStore'

export const useMuteUnmute = () => {
  const {playSound} = useSound(['confirm-up', 'confirm-down'])
  const streamStore = useStreamStore()

  const mute = (type: string, options = {isSilent: false}) => {
    const enabled = false
    if (type === 'audio') {
      streamStore.micEnabled = enabled
    } else if (type === 'video') {
      streamStore.camEnabled = enabled
    }
    if (!options.isSilent) {
      playSound('confirm-down')
    }
  }

  const unmute = (type: string) => {
    const enabled = true
    if (type === 'audio') {
      streamStore.micEnabled = enabled
    } else if (type === 'video') {
      streamStore.camEnabled = enabled
    }
  }
  return {mute, unmute}
}
